import React from 'react';
import PalettePicker from '../containers/PalettePicker';
import './App.css';
export default function App() {
  return (
    <>
      <PalettePicker />
    </>
  );
}
